import "bootstrap/dist/css/bootstrap.min.css";

import PageTop from "./assets/images/png/upwards-arrow.png";

import { Header } from './Header';
import { Footer } from './Footer';

import { About } from "./components/About";
import { Testimonials } from "./components/Testimonials";
import { WorkFlow } from "./components/WorkFlow";
import { Price } from "./components/Price";
import { FAQ } from "./components/FAQ";
import { Profile } from "./components/Profile";
import { FormSection } from "./components/Form";

export const Home = () => {

    return (
        <div style={{ fontFamily: "Noto Sans JP" }}>
            <Header />
            <main>
                {/* About  */}
                <About />
                {/* お客様の声 */}
                <Testimonials />
                {/* 制作の流れ */}
                <WorkFlow />
                {/* 料金紹介 */}
                <Price />
                {/* よくある質問 */}
                <FAQ />
                {/* プロフィール */}
                <Profile />
                {/* お問い合わせ */}
                <FormSection />
            </main>
            {/* フッター */}
            <Footer />
            {/* ページトップ */}
            <div className="fixed-bottom m-4">
                <a href="#top">
                    <img
                        src={PageTop}
                        alt="pageTopAllow"
                        className="float-end"
                        width="30px"
                    />
                </a>
            </div>
        </div>
    );
};
